import { render, staticRenderFns } from "./CouponCode.vue?vue&type=template&id=154f6d06&scoped=true"
import script from "./CouponCode.vue?vue&type=script&lang=ts"
export * from "./CouponCode.vue?vue&type=script&lang=ts"
import style0 from "./CouponCode.vue?vue&type=style&index=0&id=154f6d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f6d06",
  null
  
)

export default component.exports